import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {RequestGetTaxPercentage, RequestTaxPercentage, ResponseGetTaxPercentage} from './taxpercentage-setting.dto';
import {ResponsePaging} from '../nest-responses';

@Injectable()
export class TaxpercentageSettingApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'taxpercentage-setting';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public gettaxpercentage(payload: RequestGetTaxPercentage): Observable<ResponsePaging<ResponseGetTaxPercentage>> {
    const method: string = 'GET';
    const func: string = 'gettaxpercentage';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetTaxPercentage>>(method, url, params, urlParams, body);
  }

  public taxpercentage(payload: RequestTaxPercentage[]): Observable<any> {
    const method: string = 'POST';
    const func: string = 'taxpercentage';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/taxpercentage-setting.api.ts